module.exports = "/assets/9cae43116ebbe674979fed8d185fbe88.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/YT.png
// module id = 3159
// module chunks = 0